import { State, StateRow } from './model';

export const findRow = (id: string | number, state: State): StateRow =>
  state.rows.find((row) => row.id === id)!;
export const allExpanded = (state: State) => state.rows.every(({ expanded }) => expanded);
export const allCollapsed = (state: State) => !allCollapsed(state);
